export const ADD_USER_STEP_FIELDS = {
  1: {
    name: "Personal Information",
    fields: [
      "full_name",
      "salary",
      "email",
      "dob",
      "mobile_number",
      "gender_id",
      "profile",
      "bike_reg_number",
      "id_proofPic",
      "aadhar_card_number",
      "alternate_phone_number",
      "pan_card_number",
    ],
  },

  2: {
    name: "Company Information",
    fields: [
      "roles",
      "jbcc_supervisor_id",
      "jbcc_admin_id",
      "jn_supervisor_id",
      "jn_admin_id",
      "date_of_joining",
    ],
  },

  3: {
    name: "Bank Information",
    fields: [
      "bank_name_id",
      "ifsc",
      "account_number",
      "bank_branch",
      "ifsc_code",
    ],
  },
};